import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AckRequest } from '../models/ack-request';
import { BackendListModel } from '../models/common/list.model';
import { DeclineReason } from '../models/decline-reason';
import { RequestStatus } from '../models/request-status';
import { StatusChange } from '../models/status-change';
import { TransferReason } from '../models/transfer-reason';
import { UserList } from '../models/user-list';
import { ApiRoutes } from './apiroutes';

@Injectable({
  providedIn: 'root'
})
export class AckRequestService {
  base_url = ApiRoutes.LeadRequest;
  base_url1 = ApiRoutes.Company;
  selectedRequest;
  selecteddevName;
  constructor(private http: HttpClient) { }

  // Accept Request
  acceptRequest(req: AckRequest, id) {
    let url = `${this.base_url}request_status/${id}/accept/`;
    return this.http.put(url, req);
  }
  acceptRequest1(req: AckRequest) {
    let url = `${this.base_url}request_status/${req.id}/accept/`;
    return this.http.put(url, req);
  }

  //Reject Request
  rejectRequest(req: AckRequest, id) {
    let url = `${this.base_url}request_status/${id}/reject/`;
    return this.http.put(url, req);
  }

  //Cancel Request
  cancelRequest(req: AckRequest, id) {
    let url = `${this.base_url}request_status/${id}/cancel/`;
    return this.http.put(url, req);
  }

  //Transfer Request
  transferRequest(req: AckRequest, id) {
    let url = `${this.base_url}request_user_allocation_details/share/${id}/`;
    return this.http.put(url, req);
  }

  //Decline Reason List
  getDeclineReasons(): Observable<BackendListModel<DeclineReason>> {
    let url = `${this.base_url}decline_reason/`;
    return this.http.get<BackendListModel<DeclineReason>>(url);
  }
  //Transfer Reason List
  getTransferReasons(): Observable<BackendListModel<TransferReason>> {
    let url = `${this.base_url}transfer_reason/`;
    return this.http.get<BackendListModel<TransferReason>>(url);
  }

  //Get User List
  getUserList(): Observable<BackendListModel<UserList>> {
    let url = `${this.base_url1}user_list/?is_internal=1`;
    return this.http.get<BackendListModel<UserList>>(url);
  }
  //Get Request StatusList
  getRequestStatus(currentStatusId): Observable<BackendListModel<RequestStatus>> {
    let url = `${this.base_url}request_status/${currentStatusId}/possible_status/`;
    return this.http.get<BackendListModel<RequestStatus>>(url);
  }

  //Status Change
  requestStatusChange(req: StatusChange, reqId) {
    let url = `${this.base_url}request_status/${reqId}/status_change/`;
    return this.http.put(url, req);
  }
}
